import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@aiwyn/auth';
import { Logger } from '@aiwyn/shared';
import { take } from 'rxjs/operators';

export class AbstractEmailComponent {

  email: string = null;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected authService: AuthService,
    protected logger: Logger,
  ) { }

  init(): void {
    // Get client id from query params if accessing client portal from email url.
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
    });
  }

  logIn() {
    this.logger.info('AUTH :: AbstractEmailComponent :: logIn :: Signing the user out and redirecting to login page.');
    this.authService.signOut(true).pipe(
      take(1)
    ).subscribe();
  }
}
